// extracted by mini-css-extract-plugin
export default {"globalData":"GetAmountList_globalData__nzOBU","div":"GetAmountList_div__R0Psm"};